(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'SpecialSalesSearch',
	};

	var $form,
	    travelTypeValue,
	    _toggleDestinationsField;

	$(document)
	.ready(
		function documentReady() {
			Adzuki.Form.registerForm(form);
		}
	);

	form.load = function load()
	{
		travelTypeValue = $('#specialsalessearch-travel_type').val();
		$form           = $(form.element);

		// check if travel type field has a value from session or not and toggle destinations field
		_toggleDestinationsField(travelTypeValue);

		$('.input-sales-name')
			.on(
				'click',
				function focus(e) {
					$(this).val('');
				}
			)
		;

		Adzuki.Typeahead(
			'#specialsalessearch-supplier',
			'/Offers/searchOfferCompany'
		);
		
		$('#specialsalessearch-travel_type').on('change', function toggleDestinationField() {
			travelTypeValue = $(this).val();
				
			_toggleDestinationsField(travelTypeValue);

		});
	};

	_toggleDestinationsField = function _toggleDestinationsField(travelTypeValue)
	{
		if (travelTypeValue === '0') {
				$form.find('#destination-group-field').removeClass('hidden');

			} else {
				$form.find('#destination-group-field').addClass('hidden');
				$form.find('#specialsalessearch-destination').selectpicker('deselectAll');
				
			}
	};

}(jQuery, window.Adzuki || {}));
